import { ca } from '@cian/analytics';

type TTrackUserChatsSelect = {
  userId: number;
  unreadCount: number;
  position: number;
  isMine: boolean;
};

export function trackUserChatsSelect({ userId, unreadCount, position, isMine }: TTrackUserChatsSelect) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Select_sopr',
    label: 'Agent',
    page: {
      extra: {
        opponent_id: userId,
        count_unread: unreadCount,
        position,
        is_mine: isMine,
      },
    },
  });
}
